
import request from '@/util/http'

// 审核
export const faceRecognitionAudit=(data)=>request({
    url: '/admin/recognition/audit',
    method: 'post',
    data:JSON.stringify(data),
    headers:{
        "Content-Type": "application/json"
    },
})
// 批量审核
export const faceRecognitionAuditByList=(data)=>request({
    url: '/admin/recognition/auditByList',
    method: 'post',
    data:JSON.stringify(data),
    headers:{
        "Content-Type": "application/json"
    },
})
//根据 id 逻辑删除
export const faceRecognitionDelete=(data)=>request({
    url: '/admin/recognition/delete',
    method: 'post',
    data:JSON.stringify(data)
})
// 分页获取全部审核信息
export const faceRecognitionAllInfoPage=(params)=>request({
    url: '/admin/recognition/item/page',
    method: 'get',
    params
})
//获取当前用户审核信息
export const faceRecognitionCurrentInfoPage=()=>request({
    url: '/admin/recognition/page', 
    method: 'get',
})
//根据id 物理删除
export const faceRecognitionRemove=(id)=>request({
    url: `/admin/recognition/remove/${id}`,
    method: 'delete',
})
//保存人脸采集信息
export const faceRecognitionSave=(data)=>request({
    url: '/admin/recognition/save',
    method: 'post',
    data:JSON.stringify(data),
    headers:{
        "Content-Type": "application/json"
    },
})

